export const insurance = {
  automaticStatus: [{
    value: 0, label: '等待中'
  }, {
    value: 1, label: '已获取商业险列表'
  }, {
    value: 2, label: '已获取交强险列表'
  }, {
    value: 3, label: '明细获取中'
  }, {
    value: 4, label: '已取消'
  }, {
    value: 5, label: '已完成'
  }],
  automaticTaskType: [{
    value: 2, label: '待同步'
  }, {
    value: 3, label: '已录入'
  }, {
    value: 4, label: '同步失败'
  }, {
    value: 8, label: '已存在'
  }],
  importTaskType: [{
    value: -1, label: '失败'
  }, {
    value: 1, label: '待处理 '
  }, {
    value: 2, label: '处理中'
  }, {
    value: 20, label: '成功'
  }, {
    value: 16, label: '已取消'
  }],
  exportTaskType: [{
    value: -1, label: '失败'
  }, {
    value: 1, label: '待处理 '
  }, {
    value: 2, label: '处理中'
  }, {
    value: 4, label: '成功'
  }, {
    value: 16, label: '已取消'
  }],
  taskDetailsStatus: [{
    value: 0, label: '不限'
  }, {
    value: -1, label: '失败 '
  }, {
    value: 1, label: '成功'
  }]
}

export const coverageInfo = {
  '10501': {
    name: '交强险',
    Amount: '',
    insure: false,
    DetailId: '10501'
  },
  '10001': {
    name: '机动车损失险',
    Amount: '',
    label: '',
    min: '',
    max: '',
    sysAmount: '',
    option: [],
    insure: false,
    DetailId: '10001',
    insType: 'main',
    showMore: false,
    list: [{
      name: '附加车身划痕损失险',
      DetailId: '20202',
      option: [
        {
          value: '2000',
          label: '2000'
        }, {
          value: '5000',
          label: '5000'
        }, {
          value: '10000',
          label: '10000'
        }, {
          value: '20000',
          label: '20000'
        }
      ],
      insure: false,
      Amount: '',
      label: ''
    }, {
      name: '附加修理期间费用补偿险',
      DetailId: '20209',
      option: [
        {
          value: '100',
          label: '100元/日'
        }, {
          value: '200',
          label: '200元/日'
        }, {
          value: '300',
          label: '300元/日'
        }
      ],
      insure: false,
      Amount: '',
      label: '',
      subsidiary: 90 // 补偿天数
    }, {
      name: '附加车轮单独损失险',
      DetailId: '20220',
      option: [
        {
          value: '500',
          label: '500'
        }, {
          value: '1000',
          label: '1000'
        }, {
          value: '2000',
          label: '2000'
        }, {
          value: '3000',
          label: '3000'
        }, {
          value: '4000',
          label: '4000'
        }, {
          value: '5000',
          label: '5000'
        }, {
          value: '8000',
          label: '8000'
        }, {
          value: '10000',
          label: '10000'
        }
      ],
      insure: false,
      index: 8,
      Amount: '',
      label: ''
    },
    {
      name: '附加发动机进水损坏除外特约条款',
      DetailId: '20221',
      option: [],
      insure: false,
      Amount: '',
      label: ''
    }, {
      name: '附加新增设备损失险',
      DetailId: '20206',
      option: [],
      insure: false,
      Amount: '',
      label: ''
    }, {
      name: '附加绝对免赔率特约险（车损）',
      DetailId: '40001',
      option: [
        {
          value: '5',
          label: '5%'
        }, {
          value: '10',
          label: '10%'
        }, {
          value: '15',
          label: '15%'
        }, {
          value: '20',
          label: '20%'
        }
      ],
      insure: false,
      Amount: '',
      label: '',
      insType: 'deductible'
    }]
  },
  '10002': {
    name: '机动车第三者责任保险',
    DetailId: '10002',
    option: [{
      value: '100000',
      label: '10万'
    }, {
      value: '150000',
      label: '15万'
    }, {
      value: '200000',
      label: '20万'
    }, {
      value: '300000',
      label: '30万'
    }, {
      value: '500000',
      label: '50万'
    }, {
      value: '1000000',
      label: '100万'
    }, {
      value: '1500000',
      label: '150万'
    }, {
      value: '2000000',
      label: '200万'
    }, {
      value: '2500000',
      label: '250万'
    }, {
      value: '3000000',
      label: '300万'
    }, {
      value: '3500000',
      label: '350万'
    }, {
      value: '4000000',
      label: '400万'
    }, {
      value: '4500000',
      label: '450万'
    }, {
      value: '5000000',
      label: '500万'
    }, {
      value: '5500000',
      label: '550万'
    }, {
      value: '6000000',
      label: '600万'
    }, {
      value: '6500000',
      label: '650万'
    }, {
      value: '7000000',
      label: '700万'
    }, {
      value: '7500000',
      label: '750万'
    }, {
      value: '8000000',
      label: '800万'
    }, {
      value: '8500000',
      label: '850万'
    }, {
      value: '9000000',
      label: '900万'
    }, {
      value: '9500000',
      label: '950万'
    }, {
      value: '10000000',
      label: '1000万'
    }
    ],
    insure: false,
    Amount: '2000000',
    label: '200万',
    insType: 'main',
    showMore: false,
    list: [{
      name: '附加法定节假日限额翻倍险',
      DetailId: '20254',
      option: [],
      insure: false,
      Amount: '',
      label: ''
    }, {
      name: '附加精神损害抚慰金责任险（三者）',
      DetailId: '40012',
      option: [
        {
          value: '1000',
          label: '1000'
        }, {
          value: '2000',
          label: '2000'
        }, {
          value: '3000',
          label: '3000'
        }, {
          value: '4000',
          label: '4000'
        }, {
          value: '5000',
          label: '5000'
        }, {
          value: '10000',
          label: '10000'
        }, {
          value: '15000',
          label: '15000'
        }, {
          value: '20000',
          label: '20000'
        }, {
          value: '25000',
          label: '25000'
        }, {
          value: '30000',
          label: '30000'
        }, {
          value: '35000',
          label: '35000'
        }, {
          value: '40000',
          label: '40000'
        }, {
          value: '45000',
          label: '45000'
        }, {
          value: '50000',
          label: '50000'
        }
      ],
      insure: false,
      Amount: '',
      label: ''
    }, {
      name: '附加医保外用药责任险（三者）',
      DetailId: '40022',
      option: [{
        value: '1000',
        label: '1千'
      }, {
        value: '2000',
        label: '2千'
      }, {
        value: '3000',
        label: '3千'
      }, {
        value: '4000',
        label: '4千'
      }, {
        value: '5000',
        label: '5千'
      }, {
        value: '10000',
        label: '1万'
      },
      {
        value: '20000',
        label: '2万'
      }, {
        value: '40000',
        label: '4万'
      }, {
        value: '50000',
        label: '5万'
      }, {
        value: '100000',
        label: '10万'
      }, {
        value: '150000',
        label: '15万'
      }, {
        value: '200000',
        label: '20万'
      }, {
        value: '300000',
        label: '30万'
      }, {
        value: '500000',
        label: '50万'
      }, {
        value: '1000000',
        label: '100万'
      }, {
        value: '1500000',
        label: '150万'
      }, {
        value: '2000000',
        label: '200万'
      }, {
        value: '2500000',
        label: '250万'
      }, {
        value: '3000000',
        label: '300万'
      }, {
        value: '3500000',
        label: '350万'
      }, {
        value: '4000000',
        label: '400万'
      }, {
        value: '4500000',
        label: '450万'
      }, {
        value: '5000000',
        label: '500万'
      }, {
        value: '5500000',
        label: '550万'
      }, {
        value: '6000000',
        label: '600万'
      }, {
        value: '6500000',
        label: '650万'
      }, {
        value: '7000000',
        label: '700万'
      }, {
        value: '7500000',
        label: '750万'
      }, {
        value: '8000000',
        label: '800万'
      }, {
        value: '8500000',
        label: '850万'
      }, {
        value: '9000000',
        label: '900万'
      }, {
        value: '9500000',
        label: '950万'
      }, {
        value: '10000000',
        label: '1000万'
      }],
      insure: false,
      sharedAmount: false,
      Amount: '',
      label: ''
    }, {
      name: '附加绝对免赔率特约险（三者）',
      DetailId: '40002',
      option: [
        {
          value: '5',
          label: '5%'
        }, {
          value: '10',
          label: '10%'
        }, {
          value: '15',
          label: '15%'
        }, {
          value: '20',
          label: '20%'
        }
      ],
      insure: false,
      Amount: '',
      label: '',
      insType: 'deductible'
    }]
  },
  '10004': {
    name: '机动车车上人员责任保险(司机)',
    DetailId: '10004',
    option: [
      {
        value: '1000',
        label: '1千/座'
      }, {
        value: '2000',
        label: '2千/座'
      }, {
        value: '3000',
        label: '3千/座'
      }, {
        value: '4000',
        label: '4千/座'
      }, {
        value: '5000',
        label: '5千/座'
      }, {
        value: '6000',
        label: '6千/座'
      }, {
        value: '7000',
        label: '7千/座'
      }, {
        value: '8000',
        label: '8千/座'
      }, {
        value: '9000',
        label: '9千/座'
      }, {
        value: '10000',
        label: '1万/座'
      }, {
        value: '20000',
        label: '2万/座'
      }, {
        value: '30000',
        label: '3万/座'
      }, {
        value: '40000',
        label: '4万/座'
      }, {
        value: '50000',
        label: '5万/座'
      }, {
        value: '60000',
        label: '6万/座'
      }, {
        value: '70000',
        label: '7万/座'
      }, {
        value: '80000',
        label: '8万/座'
      }, {
        value: '90000',
        label: '9万/座'
      }, {
        value: '100000',
        label: '10万/座'
      }, {
        value: '150000',
        label: '15万/座'
      }, {
        value: '200000',
        label: '20万/座'
      }, {
        value: '250000',
        label: '25万/座'
      }, {
        value: '300000',
        label: '30万/座'
      }, {
        value: '350000',
        label: '35万/座'
      }, {
        value: '500000',
        label: '50万/座'
      }
    ],
    insure: false,
    Amount: '',
    label: '',
    insType: 'main',
    showMore: false,
    list: [{
      name: '附加精神损害抚慰金责任险（司机）',
      DetailId: '40014',
      option: [
        {
          value: '1000',
          label: '1000'
        }, {
          value: '2000',
          label: '2000'
        }, {
          value: '3000',
          label: '3000'
        }, {
          value: '4000',
          label: '4000'
        }, {
          value: '5000',
          label: '5000'
        }, {
          value: '10000',
          label: '10000'
        }, {
          value: '15000',
          label: '15000'
        }, {
          value: '20000',
          label: '20000'
        }, {
          value: '25000',
          label: '25000'
        }, {
          value: '30000',
          label: '30000'
        }, {
          value: '35000',
          label: '35000'
        }, {
          value: '40000',
          label: '40000'
        }, {
          value: '45000',
          label: '45000'
        }, {
          value: '50000',
          label: '50000'
        }
      ],
      insure: false,
      Amount: '',
      label: ''
    }, {
      name: '附加医保外用药责任险保额（司机）',
      DetailId: '40024',
      option: [{
        value: '1000',
        label: '1千'
      }, {
        value: '2000',
        label: '2千'
      }, {
        value: '3000',
        label: '3千'
      }, {
        value: '4000',
        label: '4千'
      }, {
        value: '5000',
        label: '5千'
      },
      {
        value: '10000',
        label: '1万'
      },
      {
        value: '20000',
        label: '2万'
      }, {
        value: '40000',
        label: '4万'
      }, {
        value: '50000',
        label: '5万'
      }, {
        value: '100000',
        label: '10万'
      }, {
        value: '150000',
        label: '15万'
      }, {
        value: '200000',
        label: '20万'
      }, {
        value: '300000',
        label: '30万'
      }, {
        value: '500000',
        label: '50万'
      }, {
        value: '1000000',
        label: '100万'
      }, {
        value: '1500000',
        label: '150万'
      }, {
        value: '2000000',
        label: '200万'
      }, {
        value: '2500000',
        label: '250万'
      }, {
        value: '3000000',
        label: '300万'
      }, {
        value: '3500000',
        label: '350万'
      }, {
        value: '4000000',
        label: '400万'
      }, {
        value: '4500000',
        label: '450万'
      }, {
        value: '5000000',
        label: '500万'
      }, {
        value: '5500000',
        label: '550万'
      }, {
        value: '6000000',
        label: '600万'
      }, {
        value: '6500000',
        label: '650万'
      }, {
        value: '7000000',
        label: '700万'
      }, {
        value: '7500000',
        label: '750万'
      }, {
        value: '8000000',
        label: '800万'
      }, {
        value: '8500000',
        label: '850万'
      }, {
        value: '9000000',
        label: '900万'
      }, {
        value: '9500000',
        label: '950万'
      }, {
        value: '10000000',
        label: '1000万'
      }
      ],
      insure: false,
      sharedAmount: false,
      Amount: '',
      label: ''
    }, {
      name: '附加绝对免赔率特约险（车上人员司机）',
      DetailId: '40004',
      option: [
        {
          value: '5',
          label: '5%'
        }, {
          value: '10',
          label: '10%'
        }, {
          value: '15',
          label: '15%'
        }, {
          value: '20',
          label: '20%'
        }
      ],
      insure: false,
      Amount: '',
      label: '',
      insType: 'deductible'
    }]
  },
  '10005': {
    name: '机动车车上人员责任保险(乘客)',
    DetailId: '10005',
    option: [
      {
        value: '1000',
        label: '1千/座'
      }, {
        value: '2000',
        label: '2千/座'
      }, {
        value: '3000',
        label: '3千/座'
      }, {
        value: '4000',
        label: '4千/座'
      }, {
        value: '5000',
        label: '5千/座'
      }, {
        value: '6000',
        label: '6千/座'
      }, {
        value: '7000',
        label: '7千/座'
      }, {
        value: '8000',
        label: '8千/座'
      }, {
        value: '9000',
        label: '9千/座'
      }, {
        value: '10000',
        label: '1万/座'
      }, {
        value: '20000',
        label: '2万/座'
      }, {
        value: '30000',
        label: '3万/座'
      }, {
        value: '40000',
        label: '4万/座'
      }, {
        value: '50000',
        label: '5万/座'
      }, {
        value: '60000',
        label: '6万/座'
      }, {
        value: '70000',
        label: '7万/座'
      }, {
        value: '80000',
        label: '8万/座'
      }, {
        value: '90000',
        label: '9万/座'
      }, {
        value: '100000',
        label: '10万/座'
      }, {
        value: '150000',
        label: '15万/座'
      }, {
        value: '200000',
        label: '20万/座'
      }, {
        value: '250000',
        label: '25万/座'
      }, {
        value: '300000',
        label: '30万/座'
      }, {
        value: '350000',
        label: '35万/座'
      }, {
        value: '500000',
        label: '50万/座'
      }
    ],
    insure: false,
    Amount: '',
    label: '',
    insType: 'main',
    showMore: false,
    list: [{
      name: '附加精神损害抚慰金责任险（乘客）',
      DetailId: '40015',
      option: [
        {
          value: '1000',
          label: '1000'
        }, {
          value: '2000',
          label: '2000'
        }, {
          value: '3000',
          label: '3000'
        }, {
          value: '4000',
          label: '4000'
        }, {
          value: '5000',
          label: '5000'
        }, {
          value: '10000',
          label: '10000'
        }, {
          value: '15000',
          label: '15000'
        }, {
          value: '20000',
          label: '20000'
        }, {
          value: '25000',
          label: '25000'
        }, {
          value: '30000',
          label: '30000'
        }, {
          value: '35000',
          label: '35000'
        }, {
          value: '40000',
          label: '40000'
        }, {
          value: '45000',
          label: '45000'
        }, {
          value: '50000',
          label: '50000'
        }
      ],
      insure: false,
      Amount: '',
      label: ''
    }, {
      name: '附加医保外用药责任险保额（乘客）',
      DetailId: '40025',
      option: [{
        value: '1000',
        label: '1千'
      }, {
        value: '2000',
        label: '2千'
      }, {
        value: '3000',
        label: '3千'
      }, {
        value: '4000',
        label: '4千'
      }, {
        value: '5000',
        label: '5千'
      },
      {
        value: '10000',
        label: '1万'
      },
      {
        value: '20000',
        label: '2万'
      }, {
        value: '40000',
        label: '4万'
      }, {
        value: '50000',
        label: '5万'
      }, {
        value: '100000',
        label: '10万'
      }, {
        value: '150000',
        label: '15万'
      }, {
        value: '200000',
        label: '20万'
      }, {
        value: '300000',
        label: '30万'
      }, {
        value: '500000',
        label: '50万'
      }, {
        value: '1000000',
        label: '100万'
      }, {
        value: '1500000',
        label: '150万'
      }, {
        value: '2000000',
        label: '200万'
      }, {
        value: '2500000',
        label: '250万'
      }, {
        value: '3000000',
        label: '300万'
      }, {
        value: '3500000',
        label: '350万'
      }, {
        value: '4000000',
        label: '400万'
      }, {
        value: '4500000',
        label: '450万'
      }, {
        value: '5000000',
        label: '500万'
      }, {
        value: '5500000',
        label: '550万'
      }, {
        value: '6000000',
        label: '600万'
      }, {
        value: '6500000',
        label: '650万'
      }, {
        value: '7000000',
        label: '700万'
      }, {
        value: '7500000',
        label: '750万'
      }, {
        value: '8000000',
        label: '800万'
      }, {
        value: '8500000',
        label: '850万'
      }, {
        value: '9000000',
        label: '900万'
      }, {
        value: '9500000',
        label: '950万'
      }, {
        value: '10000000',
        label: '1000万'
      }
      ],
      insure: false,
      sharedAmount: false,
      Amount: '',
      label: ''
    }, {
      name: '附加绝对免赔率特约险（车上人员乘客）',
      DetailId: '40005',
      option: [
        {
          value: '5',
          label: '5%'
        }, {
          value: '10',
          label: '10%'
        }, {
          value: '15',
          label: '15%'
        }, {
          value: '20',
          label: '20%'
        }
      ],
      insure: false,
      Amount: '',
      label: '',
      insType: 'deductible'
    }]
  },
  // '10003': {
  //   name: '全车盗抢险',
  //   DetailId: '10003',
  //   option: [],
  //   insure: false,
  //   Amount: '',
  //   insMain: true
  // },
  // '40003': {
  //   name: '绝对免赔率（盗抢）',
  //   DetailId: '40003',
  //   option: [
  //     {
  //       value: '5',
  //       label: '5%'
  //     }, {
  //       value: '10',
  //       label: '10%'
  //     }, {
  //       value: '15',
  //       label: '15%'
  //     }, {
  //       value: '20',
  //       label: '20%'
  //     }
  //   ],
  //   insure: false,
  //   Amount: ''
  // },
  '20261': {
    name: '道路救援服务特约条款',
    DetailId: '20261',
    option: [
      {
        value: '2',
        label: '2'
      }, {
        value: '7',
        label: '7'
      }, {
        value: '12',
        label: '12'
      }, {
        value: '17',
        label: '17'
      }, {
        value: '22',
        label: '22'
      }
    ],
    insure: false,
    Amount: '2',
    insType: 'add'
  },
  '20262': {
    name: '车辆安全检测特约条款',
    DetailId: '20262',
    option: [],
    insure: false,
    Amount: '1',
    insType: 'add'
  },
  '20263': {
    name: '代为驾驶服务特约条款',
    DetailId: '20263',
    option: [],
    insure: false,
    Amount: '1',
    insType: 'add'
  },
  '20264': {
    name: '代为送检服务特约条款',
    DetailId: '20264',
    option: [],
    insure: false,
    Amount: '1',
    insType: 'add'
  }
}

export const otherType = {
  codeType: [{
    value: 1,
    label: '手机短信验证码'
  }, {
    value: 2,
    label: '图片验证码'
  }, {
    value: 3,
    label: '其他验证码'// 如企业微信 等
  }, {
    value: 4,
    label: '口令' // 手机令牌
  }, {
    value: 5,
    label: '扫码' // 二维码扫码
  }]
}

export const configTypeEnum = {
  salesman: 1, // 业务员
  batchQuote: 2, // 批量报价
  scheme: 3, // 报价方案
  mobile: 4, // 默认手机号
  telephone: 5, // 默认固定电话
  ownerEmail: 6, // 车主邮箱
  applicantEmail: 7, // 投保人邮箱
  insuredEmail: 8, // 被保人邮箱
  ownerMobile: 9, // 车主手机号
  applicantMobile: 10, // 投保人手机号
  insuredMobile: 11, // 被保人手机号
  ownerAddress: 12, // 车主手机号
  applicantAddress: 13, // 投保人手机号
  insuredAddress: 14, // 被保人手机号
  policy: 20, // 积分试算
  renewalType: 21, // 续保类型
  insSort: 30, // 保司排序
  organization: 41, // 业务归属
  applicable: 42, // 积分调整设置
  astringe: 50, // 收敛算法
  coverageStrategy: 60 // AI智能报价设置
}

export default {
  insurance
}



// WEBPACK FOOTER //
// ./src/data/insurance.js